<title>{{ iagPortalWhereDoIRegisterPage.htmlTitle }}</title>
<app-section class="iagPortalRegister" [sections]="iagPortalWhereDoIRegisterPage.sections"></app-section>
<app-where-do-i-register-card [whereDoIRegisterCards]="iagPortalWhereDoIRegisterPage.whereDoIRegisterCards"></app-where-do-i-register-card>
